// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"179":"7b605971","944":"df23f4bc","962":"d6660e68"}[chunkId] + ".css";
};